import './OrderModal.css';
import { IOrderFormModal } from '@/widgets/OrderForm/types';
import OrderFormClient from '@/widgets/OrderForm/ui/OrderFormClient';

export const OrderModal = ({ content }: IOrderFormModal) => {
  return (
    <OrderFormClient display={'none'} selectedOption={content.selectedOption} content={content} />
  );
};
